import { render } from "./PrintSummaryRequiredOrders.vue?vue&type=template&id=4b8b78e0"
import script from "./PrintSummaryRequiredOrders.vue?vue&type=script&lang=js"
export * from "./PrintSummaryRequiredOrders.vue?vue&type=script&lang=js"

import "./PrintSummaryRequiredOrders.vue?vue&type=style&index=0&id=4b8b78e0&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__